import { useState } from 'react';
import { useI18n } from '../../i18n';
import { useAnnounce } from '../../ui/a11y';
import { Pill } from '../../ui/DataBits';
import { errorText, rpc } from './api';
import type { SchoolCtx } from './SchoolPage';

// K4: one language version of the safety-net message checked by a native
// speaker (a warning item, never a blocker). A changed text loses its mark
// when saved, so marking waits until the text is saved.
export function ReviewMark({ ctx, lang, reviewed, changed }: { ctx: SchoolCtx; lang: string; reviewed: boolean; changed: boolean }) {
  const { t } = useI18n();
  const announce = useAnnounce();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function toggle() {
    setBusy(true);
    setError(null);
    const r = await rpc('platform_set_safety_net_review', { p_school_id: ctx.detail.school.id, p_lang: lang, p_reviewed: !reviewed });
    setBusy(false);
    if (r.error) return setError(errorText(t, r.error));
    announce(t['pa.saved']);
    await ctx.reload();
  }

  return (
    <p className="review-mark">
      {reviewed && !changed ? <Pill kind="good">{t['r4.sn.reviewed']}</Pill> : <Pill kind="warn">{t['r4.sn.notReviewed']}</Pill>}{' '}
      {changed ? (
        <span className="form-hint">{t['r4.sn.reviewAfterSave']}</span>
      ) : (
        <button type="button" className="link-btn" disabled={busy} onClick={toggle}>
          {reviewed ? t['r4.sn.unmark'] : t['r4.sn.markReviewed']}
        </button>
      )}
      {error && <span className="error-text" role="alert"> {error}</span>}
    </p>
  );
}
